export const isTraceparentReady = (url: string): boolean => {
   try {
      const parsed = new URL(url);
      const hostname = parsed.hostname || "";

      return hostname.includes("dsp-apiproxy") || hostname === "localhost";
   } catch {
      return false;
   }
};

/**
 * Generates a W3C Trace Context header value following the traceparent format: version-traceId-parentId-traceFlags
 * - version: "00" = format version
 * - traceId: 32 hex chars = unique trace identifier across all services
 * - parentId: 16 hex chars = parent span identifier in this request
 * - traceFlags: "01" = trace is enabled/sampled
 * See: https://www.w3.org/TR/trace-context/
 */
export const generateTraceparent = (): string => {
   const version = "00";
   const traceId = Array.from(crypto.getRandomValues(new Uint8Array(16)))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
   const parentId = Array.from(crypto.getRandomValues(new Uint8Array(8)))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
   const traceFlags = "01";

   return `${version}-${traceId}-${parentId}-${traceFlags}`;
};
